import { StencilThemes } from './components/StencilThemes';
import * as themes from './themes';

const getThemeByName = (name) => {
  const themeName = Object.keys(themes).find((key) => key === name) ? name : 'DefaultTheme';
  return themes[themeName];
};

export { StencilThemes, themes, getThemeByName };
